// src/pages/PrivacyPolicy/PrivacyPolicy.js

import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <section className="privacy-page">

      {/* HERO */}
      <div className="privacy-hero">

        <p className="privacy-tag">
          ROOTLY LEGAL
        </p>

        <h1>
          Privacy Policy
        </h1>

        <p className="privacy-subtitle">
          Your privacy and personal information are important to us.
        </p>

      </div>

      {/* CONTENT */}
      <div className="privacy-container">

        <div className="privacy-card">

          <p className="updated-text">
            Last Updated: April 26, 2026
          </p>

          <h2>1. Introduction</h2>

          <p>
            Rootly Homoeopathy values your privacy. This Privacy Policy explains
            how we collect, use, and protect your personal information when you
            use our website or book an appointment with us.
          </p>

          <h2>2. Information We Collect</h2>

          <p>
            We may collect your name, phone number, email address, location,
            appointment preferences, and any details you voluntarily submit
            through forms or communication channels.
          </p>

          <h2>3. How We Use Information</h2>

          <p>
            Your information may be used to schedule appointments, contact you,
            send confirmations, improve our services, and respond to your
            inquiries.
          </p>

          <h2>4. Data Security</h2>

          <p>
            We take reasonable steps to protect your information from
            unauthorized access, misuse, or disclosure.
          </p>

          <h2>5. Third-Party Services</h2>

          <p>
            We may use trusted services such as EmailJS, Firebase, or WhatsApp
            to support bookings and communication. These services may process
            limited information required to provide functionality.
          </p>

          <h2>6. Cookies</h2>

          <p>
            Our website may use cookies or analytics tools to improve user
            experience and understand website traffic.
          </p>

          <h2>7. Your Rights</h2>

          <p>
            You may request correction or deletion of your personal information
            by contacting us directly.
          </p>

          <h2>8. Contact Us</h2>

          <p>
            If you have any questions regarding privacy, please contact Rootly
            Homoeopathy through our official website contact details.
          </p>

        </div>

      </div>

    </section>
  );
}

export default PrivacyPolicy;